var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTemplate',{staticClass:"bg_white pb48"},[_c('div',{staticClass:"pt20 pl16 pr16"},[_c('BaseBackButton',{attrs:{"text":'戻る',"route":'/keepgoing'}})],1),_vm._v(" "),_c('img',{attrs:{"src":require('@/assets/images/keepgoing/present_options.png'),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3438d21f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/keepgoing/ProductList.vue
// module id = null
// module chunks = 